import React from 'react';

export const DragHandleIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    drag_indicator
  </span>
);